/**
 * Deep-link schemes registered by the Boatsetter renter and owner apps.
 *
 * The client (handleSetActive, the auth steps) and the server (token-exchange)
 * must agree on this list. They previously kept separate copies that drifted —
 * one matched without the `://` suffix — so keep this as the single source.
 */
export const NATIVE_APP_SCHEMES = ['boatsetter-renters://', 'boatsetter-owners://'];

export const isNativeAppRedirect = (redirectTo?: string): boolean =>
  !!redirectTo && NATIVE_APP_SCHEMES.some((scheme) => redirectTo.startsWith(scheme));

/**
 * Native apps can't use the browser's Clerk session cookie. They open the web
 * auth flow in a system browser and wait for a deep link carrying a single-use
 * sign-in ticket, which /api/spa/auth/token-exchange mints.
 *
 * Navigating straight to the custom scheme instead of going through here leaves
 * the app with no ticket, so it can never establish a session.
 */
export const buildTokenExchangeUrl = (redirectTo: string): string =>
  `/api/spa/auth/token-exchange?redirect_to=${encodeURIComponent(redirectTo)}`;
